const FeudalAge = {
  id: '9',
  name: 'Feudal Age'
};

export default FeudalAge;
